import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BasePipe } from 'app/generated/generated-common';
import { of } from 'rxjs';
export enum DateOrderStyle {
	YMD = 1,
	MDY = 2,
	DMY = 3,
}

@Pipe({
name: 'dateOrderStyle'
})
export class DateOrderStylePipe extends BasePipe<DateOrderStyle> implements PipeTransform {
	static prefix = 'System.DateTime.DateOrderStyle.';
	static keys = [
		DateOrderStyle.YMD,
		DateOrderStyle.MDY,
		DateOrderStyle.DMY];
	constructor(
		protected translateService: TranslateService
	) {
		super(translateService);
	}
	toString(value: DateOrderStyle): string {
		if (value == null) {
			return null;
		}
		switch (value) {
			case DateOrderStyle.YMD: return 'YMD';
			case DateOrderStyle.MDY: return 'MDY';
			case DateOrderStyle.DMY: return 'DMY';
			default: return null;
		}
	}
	transform(value: DateOrderStyle, suffix: string, interpolateParams?: Object) {
		const str = this.toString(value);
		if (str) {
			return this.translateOne(DateOrderStylePipe.prefix + str, suffix, interpolateParams);
		}
		return of(null);
	}
}


@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	declarations: [
		DateOrderStylePipe
	],
	exports: [
		DateOrderStylePipe
	],
	providers: [
		DateOrderStylePipe
	]
})
export class DateOrderStyleModule { }
